import { render, staticRenderFns } from "./Dapingmu.vue?vue&type=template&id=24d8b710&scoped=true&"
import script from "./Dapingmu.vue?vue&type=script&lang=js&"
export * from "./Dapingmu.vue?vue&type=script&lang=js&"
import style0 from "./Dapingmu.vue?vue&type=style&index=0&id=24d8b710&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8b710",
  null
  
)

export default component.exports